<template>
  <v-dialog v-model="dialog.display" max-width="550px">
    <v-card>
      <v-card-title>
        <span class="text-subtitle-2">
          <span class="font-weight-bold secondary-font">{{
            $t("users.details.title")
          }}</span>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-container fluid grid-list-md v-if="!_.isEmpty(user)">
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-calendar-blank-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("commons.fields.created.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    $moment(user.created).format("YYYY-MM-DD HH:mm:ss")
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-account-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("security.fields.username.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{ user.username }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <template v-if="user.role === 'ROLE_PARTNER'">
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-account-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("commons.fields.balance.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      user.balance_type === "PREPAID"
                        ? user.balance
                        : $t("users.fields.balance_type.POSTPAID")
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
          </template>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="4" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1"
                  >mdi-card-account-details-outline</v-icon
                >
                <span class="text-body-1 font-weight-bold">{{
                  $t("users.fields.fullname.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    `${user.profile.first_name} ${user.profile.last_name}`
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-at</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("security.fields.email.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{ user.profile.email }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="8" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-phone-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("security.fields.phone.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="4" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{ user.profile.phone }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="6" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-shield-account-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("users.fields.role.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="6" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    $t(`users.fields.role.${user.role}`)
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="6" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-radiobox-blank</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("commons.fields.status.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="6" class="py-2">
              <div class="text-right">
                <v-chip
                  v-if="user.active"
                  color="success"
                  class="table-chips"
                  >{{ $t("commons.fields.status.activated") }}</v-chip
                >
                <v-chip v-else color="error" class="table-chips">{{
                  $t("commons.fields.status.deactivated")
                }}</v-chip>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="4" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-shield-key-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("security.fields.api_key.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{
                    user.application.api_key
                  }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-row align="center" justify="center" class="py-2">
            <v-col cols="12" sm="4" class="py-2">
              <div>
                <v-icon class="mr-2 pb-1">mdi-shield-key-outline</v-icon>
                <span class="text-body-1 font-weight-bold">{{
                  $t("security.fields.secret.title")
                }}</span>
              </div>
            </v-col>
            <v-col cols="12" sm="8" class="py-2">
              <div class="text-right">
                <v-chip color="grey lighten-3" class="table-chips mr-0">
                  <span class="text-body-2">{{ user.application.secret }}</span>
                </v-chip>
              </div>
            </v-col>
          </v-row>
          <template v-if="$objectPath.get(user, 'cga.identifier')">
            <v-divider></v-divider>
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-identifier</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("users.fields.cga.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      $objectPath.get(user, "cga.identifier")
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </template>
          <template v-if="$objectPath.get(user, 'cga_readonly.identifier')">
            <v-divider></v-divider>
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-identifier</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("users.fields.cga_readonly.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      $objectPath.get(user, "cga_readonly.identifier")
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </template>
          <template v-if="$objectPath.get(user, 'mynetwork.identifier')">
            <v-divider></v-divider>
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="7" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-identifier</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("users.fields.mynetwork_identifier.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="5" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      user.mynetwork.identifier
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-account-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("users.fields.mynetwork_username.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      user.mynetwork.username
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row align="center" justify="center" class="py-2">
              <v-col cols="12" sm="8" class="py-2">
                <div>
                  <v-icon class="mr-2 pb-1">mdi-file-key-outline</v-icon>
                  <span class="text-body-1 font-weight-bold">{{
                    $t("users.fields.mynetwork_password.title")
                  }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-2">
                <div class="text-right">
                  <v-chip color="grey lighten-3" class="table-chips mr-0">
                    <span class="text-body-2">{{
                      user.mynetwork.password
                    }}</span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          display: false,
        };
      },
    },
    user: {
      default: function() {
        return {};
      },
    },
  },
  data: () => ({}),
};
</script>
